import React from 'react';

function Title() {
  return <h1 className="title">En Carte!</h1>;
}

export default Title;
